import { capture } from "./capture";

export const DatastoresTracking = {
  /** Connection type chosen in wizard. */
  typeSelected: (datastoreType: string) => {
    capture("datastores.type_selected", { datastore_type: datastoreType });
  },

  /** "Test Connection" clicked during creation. */
  connectionTested: (datastoreType: string, result: "success" | "fail") => {
    capture("datastores.connection_tested", { datastore_type: datastoreType, result });
  },

  /** Datastore saved successfully. */
  created: (datastoreType: string) => {
    capture("datastores.created", { datastore_type: datastoreType });
  },

  /** Datastore creation API error. */
  createFailed: (datastoreType: string, error: string) => {
    capture("datastores.create_failed", { datastore_type: datastoreType, error });
  },

  /** Datastore/connection deleted. */
  deleted: (datastoreType: string) => {
    capture("datastores.deleted", { datastore_type: datastoreType });
  },

  /** "Sync Now" clicked. */
  syncTriggered: (datastoreType: string) => {
    capture("datastores.sync_triggered", { datastore_type: datastoreType });
  },

  /** Auto sync toggled on/off. */
  autoSyncToggled: (datastoreType: string, enabled: boolean) => {
    capture("datastores.auto_sync_toggled", { datastore_type: datastoreType, enabled });
  },

  /** Databases added to a datastore. */
  databasesAdded: (databaseCount: number) => {
    capture("datastores.databases_added", { database_count: databaseCount });
  },

  /** dbt Cloud token validation result. */
  dbtCloudTokenValidated: (
    valid: boolean,
    projectCount: number,
    environmentCount: number
  ) => {
    capture("datastores.dbt_cloud_token_validated", {
      valid,
      project_count: projectCount,
      environment_count: environmentCount,
    });
  },

  /** dbt Cloud connection updated. */
  dbtCloudConnectionEdited: (fieldsChanged: string[]) => {
    capture("datastores.dbt_cloud_connection_edited", {
      fields_changed: fieldsChanged.join(","),
    });
  },

  /** dbt Cloud sync triggered. */
  dbtCloudSyncTriggered: (environmentsQueued: number) => {
    capture("datastores.dbt_cloud_sync_triggered", {
      environments_queued: environmentsQueued,
    });
  },
};
